import { GlobalService } from "src/app/global.service";
import { Component, OnInit } from "@angular/core";
import { HttpService } from "src/app/http.service";
import { DomSanitizer } from "@angular/platform-browser";
import {
  ThemePalette,
  ProgressSpinnerMode,
  MatDialog,
} from "@angular/material";
import { BillAlertComponent } from "../bill-alert/bill-alert.component";

@Component({
  selector: "app-leakage-allowance",
  templateUrl: "./leakage-allowance.component.html",
  styleUrls: ["./leakage-allowance.component.scss"],
})
export class LeakageAllowanceComponent implements OnInit {
  from_date: any;
  to_date: any;
  is_document_available: boolean = true;
  route_list: any;
  selected_route_list = [];
  document_file: any = null;
  color: ThemePalette = "primary";
  pdf_data: any;
  mode: ProgressSpinnerMode = "indeterminate";
  title: any;
  route_disabled = true;

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog,
    private dom: DomSanitizer,
    private global: GlobalService
  ) {
    this.title = this.global._active_display_name;
    this.getRoutNames();
  }

  openAlert(data) {
    const dialogRef = this.dialog.open(BillAlertComponent, {
      height: '700px',
      width: '700px',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
      }
    });
  }

  getClicked() {
    let data_dict = {
      from_date: this.from_date,
      to_date: this.to_date,
      route_list: this.selected_route_list,
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveLeakageAllowanceReport(data_dict).subscribe(
      (data) => {
        this.is_document_available = true;
        console.log(data);
        if (data['is_multiple_price']) {
          this.openAlert(data);
        } else {
          this.pdf_data = this.dom.bypassSecurityTrustResourceUrl(
            "data:application/pdf;base64," + data["pdf"]
          );
          this.document_file = data;
        }
      },
      (error) => {
        this.is_document_available = true;
      }
    );
  }

  checkboxChanged(event) {
    if (event.checked) {
      this.selected_route_list = this.route_list;
      this.route_disabled = true;
    } else {
      this.selected_route_list = [];
      this.route_disabled = false;
    }
  }

  downloadClicked() {
    const linkSource =
      "data:application/pdf;base64," + this.document_file["pdf"];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file["file_name"];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_file = null;
  }

  getRoutNames() {
    console.log('called');
    this.httpService.serveRoutesForLeakage().subscribe(
      (data: any) => {
        this.route_list = data;
        this.selected_route_list = data;
        console.log(data);
      },
      (error) => {
        this.is_document_available = true;
      }
    );
  }

  ngOnInit() {}
}
